module.exports = __webpack_public_path__ + "img/blankHeatmap.106a90c4.png";